import DescriptionDetail from "src/shared/components/data-display/description-detail/DescriptionDetail"
import { formatTextWithCapitalize } from "src/shared/hooks/formatTextOpcions"
import { DetalleTabProps } from "../IncidenciasDetail.type"

const emptyValue = "-"

const formatValue = (value?: string | null) => (value && value !== emptyValue ? formatTextWithCapitalize(value) : emptyValue)

const DetalleTab = ({ data }: DetalleTabProps): JSX.Element => {
    // las fechas del reporte ya llegan formateadas desde el endpoint, se muestran igual que en la tabla
    return (
        <div className="inc-detail__description">
            <DescriptionDetail
                icon={"calendarFill"}
                label={"Fecha y hora"}
                value={data?.fecha_registro || emptyValue}
            />
            <DescriptionDetail icon={"alertFill"} label={"Estatus"} value={formatValue(data?.estado_incidencia)} />
            <DescriptionDetail icon={"alertFill"} label={"Urgencia"} value={formatValue(data?.urgencia)} />
            <DescriptionDetail icon={"surveyFill"} label={"Tipo"} value={formatValue(data?.tipo_incidencia)} />
            <DescriptionDetail
                icon={"BedFilled"}
                label={"Habitación"}
                value={data?.numero_habitacion || emptyValue}
            />
            <DescriptionDetail
                className={"inc-detail__value--full"}
                icon={"userFilled"}
                label={"Nombre del responsable"}
                value={formatValue(data?.lugar_responsable)}
            />
            <DescriptionDetail
                className={"inc-detail__value--full"}
                icon={"car"}
                label={"Detalle de auto"}
                value={data?.matricula || emptyValue}
            />
            <DescriptionDetail
                className={"inc-detail__value--full"}
                icon={"draft"}
                label={"Reportado por"}
                value={data?.reporta || emptyValue}
            />
            <DescriptionDetail
                className={"inc-detail__value--multiline"}
                icon={"chat"}
                label={"Detalle de incidencia"}
                value={data?.descripcion || emptyValue}
            />
        </div>
    )
}

export default DetalleTab
